export const apiPrefix = '/api'
export const apiAdmin = '/api/admin'
export const apiAdminOld = '/admin'
export const apiUpload = '/api/upload'
export const apiForm = '/api/form'
export const apiCabinet = 'https://academy.nethouse.ru/api/student'
export const apiPartner = '/api/partner'
export const apiPartners = '/api/partners'
export const madTestPrefix = 'https://madte.st'